import { AlreadyPaidForm } from '../components/AlreadyPaidForm';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { AlreadyPaidOptions, IGetPolicyPaymentInfoResponse } from '../shared/types';
import { useGlobalState } from '../shared/state';
import { useEffect, useState } from 'react';
import { UtagHelper } from '../utils/utagHelper';

export const AlreadyPaidPage: React.FC = () => {
  let navigate = useNavigate();
  const [startPath] = useGlobalState('startPath');
  const [policyPaymentInfo] = useGlobalState('policyPaymentInfo');
  const [, setAlreadyPaidOption] = useGlobalState('alreadyPaidOption');
  const [, setAmountChosen] = useGlobalState('amountChosen');
  const [clubTag] = useGlobalState('clubTag');
  const [policyMetaData] = useGlobalState('policyMetaData');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const { allowAutoPay } = policyPaymentInfo as IGetPolicyPaymentInfoResponse;
  const { minimumDue } = policyPaymentInfo || {};
  const [tagging, setIsTagging] = useState(true);

  useEffect(() => {
    const ins_min_due = minimumDue ? 'true' : 'false';
    const ins_autopaycampaign = allowAutoPay ? 'autopay required' : 'autopay not required';
    const ins_policy = policyMetaData.prefix;
    UtagHelper.tag({
      ...UtagHelper.loadCommonTags(),
      page: UtagHelper.getPages().alreadyPaid,
      club: clubTag,
      ins_min_due,
      ins_autopaycampaign,
      state: policyMetaData.state,
      ins_policy,
    });
    setIsTagging(false);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = (option: any) => {
    const { alreadyPaid } = option;
    setAlreadyPaidOption(alreadyPaid);

    if (alreadyPaid === AlreadyPaidOptions.AdditionalPayment) {
      navigate(Pages.PaymentSelection);
    }
    if (alreadyPaid === AlreadyPaidOptions.EnrollInAutoPay) {
      setAmountChosen(0);
      navigate(Pages.AutoPay);
    }
  };

  const navigateToStart = () => navigate(`${Pages.SubmitInsurance}${startPath}`);

  const handleNext = (e: any) => {
    if (e.yesNoToggle === 'Y') {
      navigate(Pages.PaymentSelection);
    } else {
      navigateToStart();
    }
  };

  const handleCancel = () => {
    navigateToStart();
  };

  if (tagging) {
    return <></>;
  }

  return (
    <>
      <AlreadyPaidForm
        allowAutoPay={allowAutoPay}
        handleBack={handleBack}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleNext={handleNext}
        isMobileApp={isMobileApp}
      />
    </>
  );
};
